/**
 * Matcher for "ip" condition
 *
 * Ported from [condition.testIP@910eca63e4f3eed8604542f849364aa67392c725](https://github.com/optimizely/optimizely/blob/910eca63e4f3eed8604542f849364aa67392c725/src/www/js/client/condition.js#L520).
 * @module
 */
var CIDR = require('../helpers/cidr').CIDR;

module.exports = {
  fieldsNeeded: ['IP'],
  match: function(value, cond) {
    if (!value.hasOwnProperty('IP')) {
      return false;
    }
    var visitorIP = value.IP;

    var matchString = cond['value'],
        type = cond['match'];
    switch (type) {
      case 'prefix':
        if (visitorIP.indexOf(matchString) === 0){
          return true;
        }
        break;
      case 'regex':
        try {
          var regex = new RegExp(matchString);
        }
        catch (error){
          return false;
        }

        if (regex.test(visitorIP)){
          return true;
        }
        break;
      case 'cidr':
        try {
          var cidr = new CIDR(matchString);
          return cidr.containsIP(visitorIP);
        }
        catch (error){
          return false;
        }
        break;
      default:
        if (visitorIP === matchString && visitorIP !== ''){
          return true;
        }
        break;
    }
    return false;
  }
};
